<div class="field is-grouped">
    <p class="control" *ngFor="let controls of controlGroup; let i=index">
        <app-select [controls]="controls" (indexChange)="changeSelect($event)"></app-select>
    </p>
</div>

<app-resources-table [controlGroup]="controlGroup"  [types]="types"></app-resources-table>
